import { createApp } from 'vue';
import { piniaScreensize, useScreensizeStore } from '@stores/useScreensizeStore.ts';
import { eventBus } from './event-bus';

export const deviceDetect = () => {
  createApp().use(piniaScreensize);

  const { body } = document;
  const regexResponsive = /(\s)*(is-.*?)(?=\s)/g;
  const mobileBreakpoint = 770;
  const tabletBreakpoint = 1000;
  const desktopBreakpoint = 1200;

  /**
   * setScreenBreakpoint
   *
   * @description set a class on <body> depending on window size.
   * set BREAKPOINTS Namespace with screen breakpoints
   */
  const setScreenBreakpoint = () => {
    const oldBreakpoint = { ...window.BREAKPOINTS };
    const wSize = window.innerWidth;
    const breakpoints = {
      isMobile: false,
      isTablet: false,
      isTabletLarge: false,
      isDesktop: false,
    };

    body.className = body.className.replace(regexResponsive, '');
    if (wSize < mobileBreakpoint) {
      body.classList.add('is-mobile');
      breakpoints.isMobile = true;
    } else if (wSize < tabletBreakpoint) {
      body.classList.add('is-tablet');
      breakpoints.isTablet = true;
    } else if (wSize < desktopBreakpoint) {
      body.classList.add('is-tablet-large');
      breakpoints.isTabletLarge = true;
    } else {
      body.classList.add('is-desktop');
      breakpoints.isDesktop = true;
    }
    window.BREAKPOINTS = breakpoints;

    useScreensizeStore().setBreakpoints(breakpoints);

    if (JSON.stringify(breakpoints) !== JSON.stringify(oldBreakpoint)) {
      eventBus.dispatchEvent(new CustomEvent('window-size-changed'));
    }
  };

  setScreenBreakpoint();
  window.addEventListener('resize', setScreenBreakpoint);
};
